/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ScheduleCampaignLaunchMutationRequest,
  ScheduleCampaignLaunchMutationResponse,
  ScheduleCampaignLaunchPathParams,
  ScheduleCampaignLaunch400,
} from '../types/ScheduleCampaignLaunch'

function getScheduleCampaignLaunchUrl({
  bison_campaign_id,
}: {
  bison_campaign_id: ScheduleCampaignLaunchPathParams['bison_campaign_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/emailbison/campaigns/${bison_campaign_id}/schedule-launch/` as const,
  }
  return res
}

/**
 * @description Set scheduled_launch_at and transition the campaign into SCHEDULED.
 * @summary Schedule a campaign auto-launch
 * {@link /api/v1/emailbison/campaigns/:bison_campaign_id/schedule-launch/}
 */
export async function scheduleCampaignLaunch(
  {
    bison_campaign_id,
  }: {
    bison_campaign_id: ScheduleCampaignLaunchPathParams['bison_campaign_id']
  },
  data: ScheduleCampaignLaunchMutationRequest,
  config: Partial<RequestConfig<ScheduleCampaignLaunchMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ScheduleCampaignLaunchMutationResponse,
    ResponseErrorConfig<ScheduleCampaignLaunch400>,
    ScheduleCampaignLaunchMutationRequest
  >({
    method: 'POST',
    url: getScheduleCampaignLaunchUrl({ bison_campaign_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
